import { render, staticRenderFns } from "./v-gridform-builder.vue?vue&type=template&id=161c9ebc&scoped=true&"
import script from "./v-gridform-builder.vue?vue&type=script&lang=js&"
export * from "./v-gridform-builder.vue?vue&type=script&lang=js&"
import style0 from "./v-gridform-builder.vue?vue&type=style&index=0&id=161c9ebc&scoped=true&lang=css&"
import style1 from "./v-gridform-builder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c9ebc",
  null
  
)

export default component.exports